import {mock} from './index';

export default {
  removeMessage: () => mock('/message/remove'),
  messageList: () => mock('/message/list')
};
